<div 
    [ngClass]="{ 
        'is-visible-calendar': isVisibleCalendar || isLoading
    }"
    class="vehicle-details-routes-tab"
>
    <app-vehicle-details-routes-days-switch
        (onShowCalendar)="isVisibleCalendar = true"
        (onChangeDate)="onChangeDayCalendar$.next($event)"
        [initialDate]="initialDateCalendar"
        [selectedDateCalendar]="selectedDatesInCalendar"
    ></app-vehicle-details-routes-days-switch>

    <app-vehicle-details-route-summary-data 
        [data]="vehicleRouteStatistics"
        [routes]="routes"
        [isLoading]="isLoading"
    ></app-vehicle-details-route-summary-data>

    <app-vehicle-details-routes-calendar
        (onHideCalendar)="isVisibleCalendar = false"
        (onSubmitCalendar)="onSelectDaysInCalendar($event)"
        [isVisible]="isVisibleCalendar"
    ></app-vehicle-details-routes-calendar>

    <div *ngIf="isLoading" class="is-loading-route">
        <p-skeleton *ngFor="let item of [1,1,1,1,1,1,1,1,1,1]" height="5rem"></p-skeleton>
    </div>

    <!-- routes -->
    <ng-container *ngIf="!isLoading && routes?.length">
        <div class="route-segments">
            <ng-container *ngFor="
                let dayRoutes of (routes | groupRoutesByDate);
                trackBy: trackByDayRoute
            ">
                <div
                    *ngFor="
                        let route of dayRoutes?.routes;
                        let i = index;
                        let last = last;
                        let first = first;
                        trackBy: trackByRoute
                    "
                    (click)="selectSegment(route)"
                    class="route-segment-container"
                    [ngClass]="{
                        'route-segment-container-first' : first,
                        'route-segment-container-last' : last,
                        'route-segment-container-selected': (route.Id === selectedRouteEventId)
                    }"
                >
                    <tk-vehicle-details-route-item 
                        [route]="route"
                        [points]="route.Points"
                        (onRouteEventDetailUpdate)="onRouteEventDetailUpdate($event)"
                    ></tk-vehicle-details-route-item>
                </div>

                <div class="route-segments__separator-day">
                    <div class="route-segments__separator-day__icon">
                        <i class="pi pi-calendar"></i>
                    </div>
                    <span class="route-segments__separator-day__title">
                        {{ dayRoutes.date | date: 'EEEE, d MMMM yyyy' : '' : langauge }}
                    </span>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="!routes?.length && !isLoading">
        <div class="no-routes">
            <img class="no-routes-img" src="/assets/img/empty-states/empty-state-vehicle-routes.svg" alt="">
            <h1 class="no-routes__title">
                {{'vehicle-details-routes-tab.vehicle-not-driving-part1' | translate}} {{'vehicle-details-routes-tab.vehicle-not-driving-part2' | translate}}
            </h1>
            <span class="no-routes__description">
                {{'checkOtherDays'|translate}}
            </span>
        </div>
    </ng-container>
</div>
